import useSidepanel from "@hooks/useSidepanel";
import { useCallback } from "react";
import ResourceAddSidepanel from "../components/ResourceAddSidepanel";

export default function useAddAction(options: Modules.Resource.SidepanelOptions<any>) {
    const sidepanel = useSidepanel()

    return useCallback(() => {
        sidepanel.open(ResourceAddSidepanel, options)
    }, [options.form])
}